import { ColocaButton } from "@/shared/components/buttons/ColocaButton";
import useTranslations from "@/shared/lang/useTranslations";

interface EditFormFooterProps {
  isSubmitting: boolean;
  onCancel: () => void;
  /** Optional override for the submit button label. Defaults to `edit_submit_button`. */
  submitLabel?: string;
  /** Optional override for the loading-state submit label. Defaults to `edit_submitting`. */
  submittingLabel?: string;
}

/**
 * Shared footer for the Coloca edit modals (clients + organizations). Renders `Cancel` and `Save` aligned to
 * the right.
 */
export function EditFormFooter({
  isSubmitting,
  onCancel,
  submitLabel,
  submittingLabel,
}: EditFormFooterProps) {
  const { t } = useTranslations("clients");
  return (
    <div className="flex items-center justify-end gap-2 pt-2">
      <ColocaButton type="button" variant="ghost" onClick={onCancel} disabled={isSubmitting}>
        {t("modal_cancel")}
      </ColocaButton>
      <ColocaButton type="submit" variant="primary" loading={isSubmitting} disabled={isSubmitting}>
        {isSubmitting ? (submittingLabel ?? t("edit_submitting")) : (submitLabel ?? t("edit_submit_button"))}
      </ColocaButton>
    </div>
  );
}
